import { render, staticRenderFns } from "./ModalProjectDuplicate.vue?vue&type=template&id=702c7eeb&scoped=true"
import script from "./ModalProjectDuplicate.vue?vue&type=script&lang=js"
export * from "./ModalProjectDuplicate.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectDuplicate.vue?vue&type=style&index=0&id=702c7eeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c7eeb",
  null
  
)

export default component.exports